import * as models from "./api/models";
import getValidationKey from "./getValidationKey";
import isAddressKey from "./isAddressKey";
import {EMPTY_VALUE} from "../components/Select";
import {InputValidation} from "./validateApplicationField";

const EMPTY_ARR: string[] = [];
const NOT_FOUND_VALIDATION = {isValid: true, messages: EMPTY_ARR, validationKey: null};

const SELECT_INPUTS = [models.AddressKeys.State];

const REQUIRED_INPUTS = [
    models.AddressKeys.AddressLine1,
    models.AddressKeys.City,
    models.AddressKeys.Zipcode,
];

const strings = {
    required: "Value is required.",
    invalidFormat: "is not a valid value.",
};

const REGEX = {
    zip: /[0-9]{5}/,
};

export default function validateAddressField(
    name: models.AddressKeys,
    value: string | boolean,
): InputValidation {
    const validationKey = getValidationKey(name);
    if (!isAddressKey(name)) {
        return NOT_FOUND_VALIDATION;
    }

    if (SELECT_INPUTS.find((selectName) => name === selectName)) {
        const isValid = value !== EMPTY_VALUE;
        return {
            isValid,
            messages: isValid ? EMPTY_ARR : [strings.required],
            validationKey: validationKey,
        };
    }

    const validation = {
        isValid: true,
        messages: EMPTY_ARR,
        validationKey,
    };

    if (REQUIRED_INPUTS.find((reqdName) => name === reqdName)) {
        if (typeof value === "string" && !value) {
            validation.isValid = false;
            validation.messages = [...validation.messages, strings.required];
        }
    }

    if (name === models.AddressKeys.Zipcode && typeof value === "string" && !!value) {
        const invalid = !value.match(REGEX.zip);
        if (invalid) {
            validation.isValid = false;
            validation.messages = [...validation.messages, `"${value}" ${strings.invalidFormat}`];
        }
    }

    return validation;
}
